import { render, staticRenderFns } from "./CkModalBirthdays.vue?vue&type=template&id=12d1a276&scoped=true"
import script from "./CkModalBirthdays.vue?vue&type=script&lang=js"
export * from "./CkModalBirthdays.vue?vue&type=script&lang=js"
import style0 from "./CkModalBirthdays.vue?vue&type=style&index=0&id=12d1a276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1a276",
  null
  
)

export default component.exports